(function () {
  var API = 'https://cool-steal-game.scott-af6.workers.dev';
  var STALL_TIMEOUT_MS = 90000;

  var MIN_LOADING_MS = 3000;
  var FIRST_FRAME_MS = 3000;
  var SILENT_GAME_MS = 2000;

  var PROGRESS_BATCH = 5;

  var GAME_EVENTS = {
    email_submitted: ['email', 'nickname', 'consent'],
    start: [],
    checkpoint: ['index', 'score', 'runtime', 'active_time'],
    pause: ['runtime'],
    resume: ['runtime'],
    win: ['score', 'runtime', 'active_time'],
    lose: ['progress', 'score', 'runtime', 'active_time'],
    email_confirmed: ['confirmed_email', 'claimId'],
    exit: []
  };

  function round4(value) {
    return typeof value === 'number' && isFinite(value)
      ? Math.round(value * 10000) / 10000
      : value;
  }

  function post(path, body) {
    return fetch(API + path, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () {
        return {};
      }).then(function (data) {
        if (res.ok) return data;
        var err = new Error(path + ' ' + res.status + (data.error ? ' ' + data.error : ''));
        err.status = res.status;
        throw err;
      });
    });
  }

  function emptyDelta() {
    return { attempts: 0, score_sum: 0, max_score: 0 };
  }

  function addToDelta(delta, attempts, scoreSum, maxScore) {
    delta.attempts += attempts;
    delta.score_sum += scoreSum;
    delta.max_score = Math.max(delta.max_score, maxScore);
  }

  function initGame(dialog) {
    if (dialog.hasAttribute('data-shoplift-init') || typeof dialog.showModal !== 'function') return;
    dialog.setAttribute('data-shoplift-init', '');

    var frame = dialog.querySelector('.shoplift-game__frame');
    var closeBtn = dialog.querySelector('[data-shoplift-close]');
    var mobileUrl = dialog.getAttribute('data-game-url-mobile');
    var desktopUrl = dialog.getAttribute('data-game-url-desktop');
    if (!frame || !(mobileUrl || desktopUrl)) return;

    var player = null;         
    var gating = null;         
    var run = null;             
    var progress = emptyDelta();
    var firstPlaySent = false;

    var state = 'idle'; 
    var gameUrl;
    var GAME;
    var stallTimer;
    var revealTimer;
    var silentTimer;
    var errorTimer;
    var loadStartedAt;
    var readyAt;
    var heardFromGame;
    var downloaded;

    function pickGameUrl() {
      var touch = window.matchMedia('(pointer: coarse)').matches;
      return touch ? mobileUrl || desktopUrl : desktopUrl || mobileUrl;
    }

    function logLoad(label) {
      console.log('game load:', label, ((Date.now() - loadStartedAt) / 1000).toFixed(1) + 's');
    }

    function watchStall() {
      clearTimeout(stallTimer);
      stallTimer = setTimeout(function () {
        logLoad('no message from game for ' + STALL_TIMEOUT_MS / 1000 + 's');
        fail();
      }, STALL_TIMEOUT_MS);
    }

    function startLoading() {
      if (state !== 'idle') return;
      state = 'loading';
      gameUrl = pickGameUrl();
      GAME = new URL(gameUrl, window.location.href).origin;
      loadStartedAt = Date.now();
      readyAt = 0;
      heardFromGame = false;
      downloaded = false;
      console.log('game url:', gameUrl);

      dialog.classList.add('is-loading');
      watchStall();
      frame.setAttribute('src', gameUrl);
    }

    function announce(name) {
      document.dispatchEvent(new CustomEvent(name));
    }

    function reveal() {
      if (state !== 'loading') return;

      var wait = Math.max(loadStartedAt + MIN_LOADING_MS, readyAt + FIRST_FRAME_MS) - Date.now();
      if (wait > 0) {
        clearTimeout(revealTimer);
        revealTimer = setTimeout(reveal, wait);
        return;
      }

      logLoad('revealed');
      state = 'open';
      clearTimeout(stallTimer);
      dialog.classList.remove('is-loading');
      dialog.showModal();
      document.documentElement.classList.add('shoplift-game-open');

      requestAnimationFrame(function () {
        dialog.classList.add('is-live');
      });
      announce('shoplift:ready');
    }

    function reset() {
      state = 'idle';
      clearTimeout(stallTimer);
      clearTimeout(revealTimer);
      clearTimeout(silentTimer);
      dialog.classList.remove('is-loading');
      dialog.classList.remove('is-live');
      frame.setAttribute('src', 'about:blank');
      document.documentElement.classList.remove('shoplift-game-open');
      announce('shoplift:cancel');
    }

    function onGameEvent(d) {
      var fields = GAME_EVENTS[d.type];
      if (!fields) {
        console.log('game event: unknown type', d);
        return;
      }

      var payload = {};
      fields.forEach(function (key) {
        payload[key] = round4(d[key]);
      });
      console.log('game event:', d.type, payload);

      // The backend gets the game's raw numbers, not the rounded log copy.
      if (d.type === 'email_submitted') {
        submitEmail(d);
      } else if (d.type === 'start') {
        startRun();
      } else if (d.type === 'checkpoint') {
        if (run) {
          run.checkpoints.push({ index: d.index, runtime: d.runtime, active_time: d.active_time, score: d.score });
        }
      } else if (d.type === 'win') {
        // Held until the player re-enters their email on the win screen.
        if (run) run.win = { score: d.score, runtime: d.runtime, active_time: d.active_time };
      } else if (d.type === 'lose') {
        countPlay(d.score);
      } else if (d.type === 'email_confirmed') {
        claimWin(d);
      } else if (d.type === 'exit') {
        dialog.close();
      }
    }

    function submitEmail(d) {
      gating = post('/gate', {
        email: d.email,
        nickname: d.nickname,
        consent: d.consent === true
      }).then(function (res) {
        // res.already_won is informational only; they can keep playing.
        player = res.token;
        firstPlaySent = false;
      }, function (err) {
        console.warn('shoplift gate failed:', err.message);
        player = null;
      });
    }

    // The game can only be told a session id, so reloading it is the only way back to its email form.
    function backToGate() {
      player = null;
      if (state === 'open') frame.setAttribute('src', gameUrl);
    }

    function startRun() {
      settleUnclaimedWin();

      // A fresh session per play: the server times the run from this token's issue time.
      var thisRun = run = { player: null, session: null, checkpoints: [], win: null };
      thisRun.ready = Promise.resolve(gating).then(function () {
        if (run !== thisRun) return;
        if (!player) {
          backToGate();
          return;
        }
        thisRun.player = player;
        return post('/session/start', { player: player }).then(function (res) {
          thisRun.session = res.token;
          if (run === thisRun && frame.contentWindow) {
            frame.contentWindow.postMessage({ type: 'session', sid: res.token }, GAME);
          }
        }, function (err) {
          console.warn('shoplift session failed:', err.message);
          if (err.status === 401 && run === thisRun && player === thisRun.player) backToGate();
        });
      });
    }

    function claimWin(d) {
      var thisRun = run;
      if (!thisRun || !thisRun.win) {
        console.warn('shoplift: email_confirmed without a win this run');
        return;
      }
      var win = thisRun.win;
      thisRun.win = null;

      thisRun.ready.then(function () {
        if (!thisRun.session) {
          console.warn('shoplift: no session for this run, win not submitted');
          return;
        }
        // Always { ok: true }, whatever the verdict. Klaviyo emails the result, so never show one here.
        return post('/win', {
          player: thisRun.player,
          session: thisRun.session,
          confirmed_email: d.confirmed_email,
          claim_id: d.claimId,
          checkpoints: thisRun.checkpoints,
          win: win,
          delta: { attempts: 1, score_sum: win.score, max_score: win.score }
        });
      }).catch(function (err) {
        console.warn('shoplift win failed:', err.message);
      });
    }

    // A win the player never claimed is still a play for /progress.
    function settleUnclaimedWin() {
      if (run && run.win) {
        countPlay(run.win.score);
        run.win = null;
      }
    }

    function countPlay(score) {
      score = typeof score === 'number' && isFinite(score) ? score : 0;
      addToDelta(progress, 1, score, score);
      // A player's first play is sent on its own, then every PROGRESS_BATCH plays: 1, 6, 11, ...
      if (progress.attempts >= (firstPlaySent ? PROGRESS_BATCH : 1)) sendProgress('batch');
    }

    // Deltas, not totals: the server adds each call to what it already has.
    function sendProgress(reason) {
      if (!player || !progress.attempts) return;
      var token = player;
      var sent = progress;
      progress = emptyDelta();
      firstPlaySent = true;

      // Cleared up front so plays during the request aren't lost; put back if it fails.
      post('/progress', { player: token, reason: reason, delta: sent }).catch(function (err) {
        console.warn('shoplift progress failed:', err.message);
        addToDelta(progress, sent.attempts, sent.score_sum, sent.max_score);
        if (player !== token) return;
        firstPlaySent = false;
        if (err.status === 401) player = null;
      });
    }

    function looksLikeStaleAsset(message) {
      return /unknown data format|<!doctype html|<html/i.test(String(message || ''));
    }

    function fail(reason) {
      if (state !== 'loading') return;
      reset();

      var box = document.querySelector('.error-message');
      var drawer = document.getElementById('errorDrawer');
      if (!box || !drawer) return;

      box.textContent = looksLikeStaleAsset(reason)
        ? "The game files didn't load properly. Please refresh the page and try again."
        : "Sorry, the game couldn't load. Please try again.";

      document.body.classList.add('showOverly');
      document.body.classList.add('shoplift-error');
      drawer.style.display = 'block';
      
      clearTimeout(errorTimer);
      errorTimer = setTimeout(function () {
        document.body.classList.remove('showOverly');
        document.body.classList.remove('shoplift-error');
        drawer.style.display = 'none';
      }, 6000);
    }

    window.addEventListener('message', function (e) {
      if (e.origin !== GAME || e.source !== frame.contentWindow) return;

      var d = e.data;
      if (!d || typeof d.type !== 'string') return;

      heardFromGame = true;
      if (state === 'loading') watchStall();

      if (d.type === 'progress') {
        if (d.value >= 1) {
          logLoad('engine started');
        } else if (d.value >= 0.9 && !downloaded) {
          downloaded = true;
          logLoad('downloaded');
        }
      } else if (d.type === 'ready') {
        logLoad('ready');
        if (!readyAt) readyAt = Date.now();
        reveal();
      } else if (d.type === 'error') {
        console.error('game error', d.message, '| url:', gameUrl);
        fail(d.message);
      } else {
        onGameEvent(d);
      }
    });

    frame.addEventListener('load', function () {
      if (state !== 'loading') return;
      clearTimeout(silentTimer);
      silentTimer = setTimeout(function () {
        if (heardFromGame) return;
        logLoad('game is not messaging this origin, revealing without progress');
        readyAt = Date.now();
        reveal();
      }, SILENT_GAME_MS);
    });

    document.addEventListener('keydown', function (e) {
      if (state === 'loading' && e.key === 'Escape') reset();
    });

    dialog.addEventListener('close', function () {
      settleUnclaimedWin();
      sendProgress('exit');
      run = null;
      reset();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    document.querySelectorAll('[aria-controls="' + dialog.id + '"]').forEach(function (btn) {
      btn.addEventListener('click', startLoading);
    });
  }

  function initAll(root) {
    root.querySelectorAll('dialog.shoplift-game').forEach(initGame);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
